import classNames from 'classnames';
import DPBoundingBox from './../modules/DPBoundingBox';

export const $S = (selector, def = null) => {
	try {
		return $(selector);
	} catch (error) {
		return def;
	}
};

export const isTouchDevice = () => {
	try {
		return (('ontouchstart' in window)
			|| (navigator.maxTouchPoints > 0)
			|| (navigator.msMaxTouchPoints > 0));
	} catch (exception) {
		return false;
	}
};

export const i18n = (text, translations) => {
	if (translations[text]) return translations[text];
	return text;
};

export const getMobileBottomControlHeight = (width, mobileBreakPointWidth) => {
	/*if (mobileBreakPointWidth && isTouchDevice() && width < mobileBreakPointWidth) {
		return - 0.08 * $(window).innerHeight();
	}*/
	return 0;
};

export const getDocBB = (mobileBreakPointWidth) => {
	/*const body = document.body;
	const html = document.documentElement;
	const height2 = Math.max(body.scrollHeight, body.offsetHeight,
		html.clientHeight, html.scrollHeight, html.offsetHeight);
	const width2 = Math.max(body.scrollWidth, body.offsetWidth,
		html.clientWidth, html.scrollWidth, html.offsetWidth);*/

	const width = $('body').prop('clientWidth');
	let height = $('body').prop('clientHeight');
	height += getMobileBottomControlHeight(width, mobileBreakPointWidth);
	return DPBoundingBox.actualizeBottomAndRight({ top: 0, left: 0, width: width, height: height });
};


export const getWinBB = (mobileBreakPointWidth) => {
	const width = $(window).innerWidth();
	let height = $(window).innerHeight();
	height += getMobileBottomControlHeight(width, mobileBreakPointWidth);
	return DPBoundingBox.actualizeBottomAndRight({ top: 0, left: 0, width: width, height });
};


export const hideElementImmediately = (htmlEl, byOpacity = true, noSpace = false) => {
	const transitionBkp = htmlEl.style.transition;
	htmlEl.style.transition = 'unset !important';
	hideElement(htmlEl, byOpacity, noSpace);
	htmlEl.style.transition = transitionBkp;
};


export const hideElement = (htmlEl, byOpacity = true, noSpace = false) => {
	if (htmlEl) {
		$(htmlEl).addClass(classNames({
			'dpit-hidden': true,
			'dpit-hidden-by-disp': !byOpacity,
			'dpit-hidden--no-space': noSpace,
		}));
	}
};

export const showElement = (htmlEl, resetInlineOpacityTo = '') => {
	if (htmlEl) {
		if (resetInlineOpacityTo !== null && resetInlineOpacityTo !== true) {
			$(htmlEl).css('opacity', resetInlineOpacityTo);
		}
		$(htmlEl).removeClass('dpit-hidden dpit-hidden--no-space dpit-hidden-by-disp dpit-hidden-by-opacity');
	}
};

export const dpZIndex = (increment = 0) => {
	return `calc(var(--dp-z-index-base) + ${increment})`;
};


export const getTransitionDurationMs = (htmlEl, def = 0) => {
	if (htmlEl) {
		let overlayContainerStyle = window.getComputedStyle(htmlEl);
		if (overlayContainerStyle && overlayContainerStyle.transitionDuration) {
			let num = parseFloat(overlayContainerStyle.transitionDuration);
			if (!isNaN(num)) {
				if (overlayContainerStyle.transitionDuration.endsWith('ms')) return num;
				else if (overlayContainerStyle.transitionDuration.endsWith('s')) return num * 1000;
				else return num;
			}
		}
	}
	return def;
};


export const getCssVarVal = (layer, variableName, def = null) => {
	let res = def;
	if (layer && variableName) {
		const tmp = getComputedStyle(layer).getPropertyValue(variableName);
		if (tmp !== null && tmp !== undefined && tmp !== '') {
			res = tmp;
		}
	}
	return res;
};

export const getCssValFloat = (htmlEl, cssParam, def = 0) => {
	let res = def;
	if (htmlEl && cssParam) {
		res = parseFloat($(htmlEl).css(cssParam));
		if (isNaN(res)) res = def;
	}
	return res;
};

export const getIntVal = (value, def = null) => {
	let res = def;
	res = parseFloat(value);
	if (isNaN(res)) res = def;
	return res;
};


export const getReverseBasePos = (pos) => {
	switch (pos) {
		case 'left': return 'right';
		case 'right': return 'left';
		case 'top': return 'bottom';
		case 'bottom': return 'top';
	}
	return pos;
};




